// Sector choices shared by the project form and the Data Room quick create.
export const sectorOptions = [
  {
    label: "Partnerships",
    value: "Partnerships"
  },
  {
    label: "Femtech Analytics Projects",
    value: "Femtech Analytics Projects"
  },
  {
    label: "Ecosystem Projects",
    value: "Ecosystem Projects"
  },
  {
    label: "Projects Manuals",
    value: "Projects Manuals"
  },
  {
    label: "Organization Manuals",
    value: "Organization Manuals"
  },
  {
    label: "Whitelabel Solutions",
    value: "Whitelabel Solutions"
  },
  {
    label: "Investable Projects",
    value: "Investable Projects"
  },
  {
    label: "Business Cooperation",
    value: "Business Cooperation"
  },
  {
    label: "Analytical Dashboards",
    value: "Analytical Dashboards"
  },
  {
    label: "Ecosystems As A Service",
    value: "Ecosystems As A Service"
  },
  {
    label: "Longevity Projects",
    value: "Longevity Projects"
  },
  {
    label: "DeepTech Projects",
    value: "DeepTech Projects"
  },
  {
    label: "Philanthropy Projects",
    value: "Philanthropy Projects"
  },
  // {
  //   label: "Thematic Projects",
  //   value: "Thematic Projects",
  // },
  // {
  //   label: "BioMed Projects",
  //   value: "BioMed Projects",
  // },
  {
    label: "SaaS Projects",
    value: "SaaS Projects"
  },
  {
    label: "AI Industry Projects",
    value: "AI Industry Projects"
  },
  {
    label: "GovTech Projects",
    value: "GovTech Projects"
  },
  {
    label: "Life Sciences Projects",
    value: "Life Sciences Projects"
  }
];
